import React from "react";
import GenericDrawer from "./GenericDrawer";
import { useSelector } from "react-redux";
import { AccountSelectors, UserContextSelectors } from "../../redux/selectors";
import { useDispatch } from "react-redux";
import { useClickOutside, useNoScroll } from "../../hooks";
import { AccountActionCreators } from "../../redux/action-creators";
import { DrawerType, VerticalTransition } from "../../constants";
import MyAccountArea from "../MyAccountArea/MyAccountArea";
import MyAccountAreaHeader from "../MyAccountArea/components/MyAccountAreaHeader/MyAccountAreaHeader";

const MyAccountAreaDrawer = () => {
  const myAccountAreaVisible = useSelector(AccountSelectors.drawerActive);
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const dispatch = useDispatch();
  const drawerRef = useClickOutside(
    () => {
      dispatch(AccountActionCreators.toggleAccountDrawer());
    },
    {
      disabled: !myAccountAreaVisible,
      ignoreClass: "aCprofilePic"
    }
  );

  useNoScroll("myAccountAreaDrawer", myAccountAreaVisible);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      className="myAccountAreaDrawer"
      isVisible={myAccountAreaVisible}
      menu={DrawerType.MyAccountArea}
      header={<MyAccountAreaHeader drawerType={DrawerType.MyAccountArea} />}
      verticalTransition={
        isMobile ? VerticalTransition.Right : VerticalTransition.Left
      }
    >
      <MyAccountArea />
    </GenericDrawer>
  );
};

export default React.memo(MyAccountAreaDrawer);
